import {SaveSaleVehicleLeasingBody} from '@dms/api/vehicle';

import {Nullish} from 'shared/web';

export function resolveLeasingCurrency(
  vehicleLeasingBody: SaveSaleVehicleLeasingBody | Nullish,
  fallbackCurrency: string
) {
  return vehicleLeasingBody?.commonParameters.listPrice?.currency ?? fallbackCurrency;
}
